// Animation utility classes for consistent transitions
export const TRANSITIONS = {
  DEFAULT: 'transition-all duration-300 ease-in-out',
  FAST: 'transition-all duration-200 ease-in-out',
  SLOW: 'transition-all duration-500 ease-in-out',
  SCALE: 'transform transition-transform duration-200 hover:scale-105',
  BUTTON: 'transform transition-all duration-200 active:scale-95 hover:scale-[1.02]',
  CARD: 'transform transition-all duration-300 hover:scale-[1.02] hover:shadow-lg',
  ICON: 'transform transition-transform duration-200 group-hover:rotate-12',
  SLIDE_UP: 'animate-[slideUp_0.3s_ease-out]',
  FADE_IN: 'animate-[fadeIn_0.3s_ease-out]'
};